import React from 'react'
import merge from 'lodash/merge'

const AppStateContext = React.createContext()
const AppDispatchContext = React.createContext()

function appReducer(state, action) {
  switch (action.type) {
    case 'setFields': {
      return {
        ...state,
        fields: action.payload,
      }
    }
    case 'setField': {
      const fields = [...state.fields]
      const field = fields.find((x) => x.name === action.payload.name)

      if (field) {
        field.value = action.payload.value
        field.hasError = false
      }

      return {
        ...state,
        fields,
      }
    }
    case 'setValues': {
      return {
        ...state,
        values: merge({}, state.values, action.payload),
      }
    }
    case 'setValue': {
      const values = { ...state.values }
      values[action.payload.name] = action.payload.value

      return {
        ...state,
        values,
      }
    }
    default: {
      throw new Error(`Unhandled action type: ${action.type}`)
    }
  }
}

/* eslint-disable-next-line react/prop-types */
function AppProvider({ children }) {
  const [state, dispatch] = React.useReducer(appReducer, {
    fields: [],
    values: {},
  })

  return (
    <AppStateContext.Provider value={state}>
      <AppDispatchContext.Provider value={dispatch}>{children}</AppDispatchContext.Provider>
    </AppStateContext.Provider>
  )
}

function useAppState() {
  const context = React.useContext(AppStateContext)

  if (context === undefined) {
    throw new Error('useAppState must be used within a AppProvider')
  }

  return context
}

function useAppDispatch() {
  const context = React.useContext(AppDispatchContext)

  if (context === undefined) {
    throw new Error('useAppDispatch must be used within a AppProvider')
  }

  return context
}

export { AppProvider, useAppState, useAppDispatch }
